<app-notification-layout
  [desktopImageSrc]="step === 1 ? '/Sim-ICCD.png' : '/Sim-puk.png'"
  [mobileImageSrc]="step === 1 ? '/Sim-ICCD.png' : '/Sim-puk.png'"
  [title]="step === 3 ? '¿Todo bien?' : '¡Ya casi estamos!'"
  [subtitle]="
    step === 3
      ? 'Revisa que los datos de tu SIM estén correctos y dale confirmar.'
      : '¡Dinos el serial y el PUK de tu SIM y te conectamos con lo bueno.'
  "
  [showFooter]="false"
>
  <form [formGroup]="simcardForm" class="mt-15 p-4 flex-1">
    <!-- Step 1: ICCD Input -->
    <div *ngIf="step === 1" class="space-y-6">
      <div class="relative z-0 w-full mb-6 group">
        <input
          matInput
          type="text"
          formControlName="iccd"
          id="iccd"
          class="block py-2.5 px-0 w-full text-lg text-gray-900 bg-transparent mt-10 border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 peer"
          [ngClass]="{
            'border-red-500':
              simcardForm.get('iccd')?.invalid &&
              simcardForm.get('iccd')?.touched,
            'border-gray-300 focus:border-red-600': !(
              simcardForm.get('iccd')?.invalid &&
              simcardForm.get('iccd')?.touched
            ),
          }"
          placeholder="Ingresa ICCD"
        />
        <!-- <label
          htmlFor="iccd"
          class="absolute text-lg text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:left-0 peer-focus:text-red-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          [ngClass]="{'text-red-500': simcardForm.get('iccd')?.invalid && simcardForm.get('iccd')?.touched}"
        >
          Ingresa ICCD
        </label> -->
        <p
          *ngIf="
            simcardForm.get('iccd')?.invalid && simcardForm.get('iccd')?.touched
          "
          class="mt-2 text-sm text-red-600"
        >
          ICCD Requerido
        </p>
      </div>
      <div class="flex justify-between">
        <button
          (click)="step = 1"
          routerLink="/"
          class="bg-white w-[169px] h-[51px] text-[15px] uppercase text-red-500 border text-center rounded-full p-4 font-extrabold text-xl"
        >
          Cancelar
        </button>
        <button
          (click)="handleNext()"
          [disabled]="simcardForm.get('iccd')?.invalid"
          class="bg-red-500 w-[169px] h-[51px] text-[15px] uppercase text-white rounded-full p-4 font-extrabold text-xl disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Continuar
        </button>
      </div>
    </div>

    <!-- Step 2: PUK Input -->
    <div *ngIf="step === 2" class="space-y-6">
      <div class="relative z-0 w-full mb-6 group">
        <input
          type="text"
          formControlName="puk"
          id="puk"
          class="block py-2.5 px-0 w-full text-lg text-gray-900 bg-transparent border-0 border-b-2 mt-10 appearance-none focus:outline-none focus:ring-0 peer"
          [ngClass]="{
            'border-red-500':
              simcardForm.get('puk')?.invalid &&
              simcardForm.get('puk')?.touched,
            'border-gray-300 focus:border-red-600': !(
              simcardForm.get('puk')?.invalid && simcardForm.get('puk')?.touched
            ),
          }"
          placeholder="Ingresa PUK"
          required
        />
        <!--   <label
          htmlFor="puk"
          class="absolute text-lg text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 z-10 origin-[0] peer-focus:left-0 peer-focus:text-red-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          [ngClass]="{'text-red-500': simcardForm.get('puk')?.invalid && simcardForm.get('puk')?.touched}"
        >
          Ingresa PUK
        </label> -->
        <p
          *ngIf="
            simcardForm.get('puk')?.invalid && simcardForm.get('puk')?.touched
          "
          class="mt-2 text-sm text-red-600"
        >
          PUK es requerido
        </p>
      </div>
      <div class="flex justify-between">
        <button
          (click)="step = 1"
          class="bg-white w-[169px] h-[51px] text-[15px] uppercase text-red-500 border text-center rounded-full p-4 font-extrabold text-xl"
        >
          Cancelar
        </button>
        <button
          (click)="handleNext()"
          [disabled]="simcardForm.get('puk')?.invalid"
          class="bg-red-500 w-[169px] h-[51px] text-[15px] uppercase text-white text-center rounded-full p-4 font-extrabold text-xl disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Continuar
        </button>
      </div>
    </div>

    <!-- Step 3: Confirmation Screen -->
    <div *ngIf="step === 3" class="space-y-6">
      <div
        class="bg-gray-50 p-6 rounded-lg border border-gray-200 shadow-inner space-y-4"
      >
        <!-- ICCD -->
        <div
          class="flex items-center justify-between pb-2 border-b border-gray-200"
        >
          <span class="text-gray-600 font-medium text-lg">ICCD</span>
          <div class="flex items-center gap-2">
            <ng-container *ngIf="!editMode['iccd']; else iccdEdit">
              <span class="text-gray-900 text-md font-semibold">{{
                simcardForm.get("iccd")?.value || "N/A"
              }}</span>
              <button (click)="toggleEdit('iccd')" type="button">
                <img src="edit-btn.svg" alt="Edit Icon" />
              </button>
            </ng-container>
            <ng-template #iccdEdit>
              <mat-form-field appearance="fill" class="w-full">
                <input
                  matInput
                  type="text"
                  formControlName="iccd"
                  id="edit-iccd"
                  (blur)="toggleEdit('iccd')"
                />
              </mat-form-field>
            </ng-template>
          </div>
        </div>

        <!-- PUK -->
        <div class="flex items-center justify-between">
          <span class="text-gray-600 font-medium text-lg">PUK</span>
          <div class="flex items-center gap-2">
            <ng-container *ngIf="!editMode['puk']; else pukEdit">
              <span class="text-gray-900 text-md font-semibold">{{
                simcardForm.get("puk")?.value || "N/A"
              }}</span>
              <button
                (click)="toggleEdit('puk')"
                type="button"
                aria-label="Editar PUK"
              >
                <img src="edit-btn.svg" alt="Edit Icon" />
              </button>
            </ng-container>
            <ng-template #pukEdit>
              <mat-form-field appearance="fill" class="w-full">
                <input
                  matInput
                  type="text"
                  formControlName="puk"
                  id="edit-puk"
                  (blur)="toggleEdit('puk')"
                />
              </mat-form-field>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="flex justify-center gap-4 mt-6 w-full text-center">
        @if (isLoading) {
          <div class="p-4">
            <mat-spinner></mat-spinner>
          </div>
        } @else {
          <button
            (click)="onSubmit()"
            class="w-[169px] h-[51px] text-[15px] bg-red-500 uppercase text-white rounded-full p-4 font-extrabold text-xl disabled:opacity-50 disabled:cursor-not-allowed"
            [disabled]="!simcardForm.valid"
          >
            Confirmar
          </button>
        }
      </div>
    </div>
  </form>
  <ng-container *ngIf="step === 3 && error">
    <p class="text-red-500 w-full text-center font-bold">
      Error en tus datos valida nuevamente
    </p>
  </ng-container>
</app-notification-layout>

<ng-container *ngIf="step !== 3">
  <div class="steps">
    <img src="/Footer-alert.png" alt="" class="steps__bg" />

    <div class="steps__dots">
      <div
        (click)="step = 1"
        class="dot"
        [class.is-active]="step === 1"
        aria-label="Paso 1"
      ></div>

      <div
        (click)="step = 2"
        class="dot"
        [class.is-active]="step === 2"
        aria-label="Paso 2"
      ></div>
    </div>
  </div>
</ng-container>
